import * as React from 'react'
import { observer } from 'mobx-react'

const Sandbox = observer(() => {
    return <></>
})

export default Sandbox
